/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-08-06 18:54:17
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-06 19:18:35
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Col, Form, Modal, notification, Table } from 'antd'
import _, { sum } from 'lodash'
import React, { ReactElement, useContext, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { ThemeContext } from '../../../theme/ThemeContext'
import { Columns } from './column'
import { Query } from './Query'
import styles from './MERecord.module.css'
import { getPEIManagementListAsync, getRemoveAsync } from '../PEIManagement/PEIManagementSlice'

export const MERecordList = (props: {
  selectKey?: string
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [total, setTotal] = useState<any>()

  const [data, setData] = useState<any[]>([])

  const [queries, setQueries] = useState<any>({
    current: 1,
    size: 10,
  })

  const [pageLoading, setPageLoading] = useState(false) // 表格 loading

  const getDataList = () => {
    setPageLoading(true)
    dispatch(getPEIManagementListAsync({ ...queries }))
      .then(unwrapResult)
      .then((res: any) => {
        setData(res.records)
        setTotal(res.total)
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    if (props?.selectKey == '2') {
        getDataList()
    }
  }, [queries, props?.selectKey])

  return (
    <Col className={styles.content}>
      <Col
        className={styles.contentMain}
        style={{
          flex: 1,
          backgroundColor: theme.pn,
        }}
      >
        <Query
          loading={pageLoading}
          add={() => {
            setIsModalVisible(true)
          }}
          onValueChange={(v) => {
            setQueries({ ...queries, ...v, current: 1 })
          }}
        />
        <EditableList
          loading={pageLoading}
          page={{
            items: data,
            current: queries.current || 1,
            size: queries.size || 10,
            total: total,
          }}
          columns={Columns((queries.size || 10) * ((queries.current || 1) - 1))}
          onChangePage={(current: any, size: any) => {
            setQueries({
              ...queries,
              current,
              size,
            })
          }}
        />
      </Col>
    </Col>
  )
}
